import { useFormContext } from "react-hook-form";
import { FormFieldProps, UseFormFieldProps } from "../Form.types";
import {
  ErrorText,
  FormFieldDescription,
  FormFieldLabel,
  FormFieldWrapper,
  RequiredLabel,
} from "./FormField.styles";

export const useFormField = <P extends UseFormFieldProps>(props: P) => {
  const { label, description, name, required, ...otherProps } = props;
  const id = name;

  return {
    formFieldProps: { id, name, label, description, required },
    childProps: { ...otherProps, id, name, required },
  };
};

function FormField({ children, name, id, label, description, required }: FormFieldProps) {
  const form = useFormContext();
  const { error } = form.getFieldState(name, form.formState);
  return (
    <FormFieldWrapper>
      <FormFieldLabel htmlFor={id}>
        {label} {required === true && <RequiredLabel>&nbsp;*</RequiredLabel>}
      </FormFieldLabel>
      {children}
      {description && <FormFieldDescription>{description}</FormFieldDescription>}
      <ErrorText aria-hidden={!error?.message} hasError={!!error?.message}>
        {error?.message ?? ""}
      </ErrorText>
    </FormFieldWrapper>
  );
}

export default FormField;
